import { Dialog } from "@mui/material";
import { IoWarningOutline } from "react-icons/io5";

/**
 * Warning dialog for a be-olin-pbf 409 refusal (cart add/update, checkout
 * submit). Shows the backend message as-is, one line per refused item.
 * CHECKOUT_IN_PROGRESS gets "Coba lagi" (onRetry) beside "Tutup".
 */
const PbfRefusalDialog = ({ error, title, onClose, onRetry }) => {
  const inProgress = error?.detail?.error_code === "CHECKOUT_IN_PROGRESS";

  return (
    <Dialog
      open={!!error}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: "16px" } }}
    >
      <div className="py-4 px-8 bg-white text-center text-[#2C3E5D]">
        <IoWarningOutline className="text-[40px] text-[#F5A623] mx-auto mb-2" />
        <p className="text-[20px] mb-2">{title}</p>
        <p className="text-[14px] mb-4 whitespace-pre-line">
          {error?.message?.id ?? error?.message}
        </p>
        <div className="flex items-center gap-2">
          {inProgress ? (
            <>
              <button
                type="button"
                className="py-2 w-full rounded-md hover:bg-gray-300 border-2 border-[#F5A623] text-[#F5A623] bg-[#FFF8EB]"
                onClick={onClose}
              >
                Tutup
              </button>
              <button
                type="button"
                className="py-2 w-full rounded-md hover:bg-gray-300 text-white bg-[#F5A623]"
                onClick={onRetry}
              >
                Coba lagi
              </button>
            </>
          ) : (
            <button
              type="button"
              className="py-2 w-full rounded-md hover:bg-gray-300 text-white bg-[#F5A623]"
              onClick={onClose}
            >
              Oke
            </button>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default PbfRefusalDialog;
